import React from 'react';
import PropTypes from 'prop-types';
import styles from './index.css';
import { rel } from '@ifeng-fe/container_channel/common/client/utils/rel';
import errorBoundary from '@ifeng-fe/errorBoundary';

import Share from '../share';

class GlobalNewList extends React.PureComponent {
    getMore = () => {
        this.props.getMore();
    };

    render() {
        const { content, isEnd, loading } = this.props;
        let prevDate = '';

        return (
            <div className={styles.list}>
                <ul>
                    {content.length > 0
                        ? content.map((item, index) => {
                              const newsTime = item.newsTime;
                              const date = newsTime.slice(0, 10);
                              const time = newsTime.slice(newsTime.indexOf(' '));

                              if (date !== prevDate) {
                                  prevDate = date;

                                  return (
                                      <React.Fragment key={index}>
                                          <li className={styles.timeTit}>{`${date.slice(0, 4)} 年 ${date.slice(
                                              5,
                                              7,
                                          )} 月 ${date.slice(8)} 日`}</li>
                                          <li className="clearfix">
                                              <p className={styles.time}>{time}</p>
                                              <a className={styles.title} href={item.url} rel={rel}>
                                                  <span>{item.title}</span>
                                              </a>
                                              <Share
                                                  url={item.url}
                                                  title={item.title}
                                                  picUrl="http://p0.ifengimg.com/a/2016/0704/finance-logo.png"
                                              />
                                          </li>
                                      </React.Fragment>
                                  );
                              } else {
                                  return (
                                      <li key={index} className="clearfix">
                                          <p className={styles.time}>{time}</p>
                                          <a className={styles.title} href={item.url} rel={rel}>
                                              <span>{item.title}</span>
                                          </a>
                                          <Share
                                              url={item.url}
                                              title={item.title}
                                              picUrl="http://p0.ifengimg.com/a/2016/0704/finance-logo.png"
                                          />
                                      </li>
                                  );
                              }
                          })
                        : ''}
                </ul>
                {loading ? <div className={styles.loading} /> : null}
                {isEnd ? (
                    <div className={styles.all}>已显示全部</div>
                ) : (
                    <div className={styles.more} onClick={this.getMore}>
                        查看更多
                    </div>
                )}
            </div>
        );
    }
}

GlobalNewList.propTypes = {
    content: PropTypes.array,
    getMore: PropTypes.func,
    isEnd: PropTypes.bool,
    loading: PropTypes.bool,
};
GlobalNewList.defaultProps = {};

export default errorBoundary(GlobalNewList);
